import TruncateStrings from '../tools/TruncateStrings'
import Vivus from '../../components/vivus'
import Swiper from '../../components/swiper'
import async from '../../components/async.min'
import * as _ from '../../components/lodash'

export default class Home
{
    constructor( )
    {
        this.$elem = $('.Page.Home')

        if( this.$elem.length > 0 ){
            let self = this

            $(document).ready(function(){
                self.truncateStrings = new TruncateStrings()

                self.$headerSlideProducts = {}
                self._header()
                self.$productSlide = {}
                self._products()
                self.$newsSlide = {}
                self._news()
                self.svgSostenibilidad = []
                self._sustainability()
            })
        }
    }

    _header(){
        let $products = $('.Home__header__products')
        let $itemCategory = $products.find('.item .item__categories')
        let $itemProducts = $products.find('.item .item__products')
        
        let generatorSlidesProducts = ( elems ) => {
            $.each(elems, function( i,val ){
                let itemToShow = window.innerWidth >= 768 ? 3 : 2

                if( $(this).children('.product').length > itemToShow ){
                    $(this).addClass('with-slide')
                    $(this).children('.product').addClass('swiper-slide')
                    $(this).append( '<div class="swiper-wrapper"></div>' )
                    $(this).append( '<div class="swiper-pagination"></div>' )

                    $.each($(this).find('.product'), function( i,val ){
                        $(this).siblings('.swiper-wrapper').append( $(this) )
                    })

                    let id = $(this).attr('id').replace(' ', '_')

                    $(this).attr('id', id)

                    this.$headerSlideProducts = new Swiper('#' + id, {
                        slidesPerView: itemToShow,
                        pagination: '.swiper-pagination',
                        paginationClickable: true
                    })
                } else{
                    $(this).addClass('grid-noGutter-middle-center whitout-slide')

                    $.each($(this).find('.product'), function( i,val ){
                        $(this).addClass('col')
                    })
                }
            })
        }

        let crossbrowsing = () => {
            if( $('html').hasClass('safari7') || ( $('html').hasClass('safari9') && $('html').hasClass('ipad') )  ){
                let totalHeight = 0
                
                $.each($itemCategory, function( i,val ){
                    if( i == $itemCategory.length - 1 ){
                        totalHeight += $(this).outerHeight()
                    }
                    else{
                        totalHeight += $(this).outerHeight() + 1
                    }

                    $.each($(this).siblings().find('.product img'), function( i,val ){
                        let currentsrc = $(this).attr('src')

                        $(this).attr('src', currentsrc + '?v=1');
                    })
                })

                $('.Home__header__products__container').css({
                    'height' : totalHeight
                })
            }

            if( $('html').hasClass('safari8') || $('html').hasClass('safari9') ){
                let $items = $('.Home__header__products__container .item')

                $.each($items, function( i,val ){
                    let $category = $(this).find('.item__categories')

                    $(this).css({
                        'min-height' : $category.outerHeight()
                    })
                })
            }
        }

        // show to products
        $itemCategory.on('click', function( event ){
            event.preventDefault()
            event.stopPropagation()

            $(this).addClass('active')

            $(this).parent().siblings().find('.item__categories').removeClass('active')
        })
        // back to category
        $itemProducts.find('.item__products__backButton').on('click', function( event ){
            event.preventDefault()
            event.stopPropagation()

            $(this).parent().siblings().removeClass('active')

            let self = $(this)
            setTimeout(function(){
                if( self.parent().hasClass('with-slide') ){
                    self.siblings('.swiper-pagination').children().first().trigger('click')
                }
            }, 400)
        })

        generatorSlidesProducts($itemProducts)
        crossbrowsing()

        if( !Modernizr.objectfit ){
            $feature.addClass('support')
        }

        $(window).resize( ()=> {
            crossbrowsing()
        })

        $(window).on("orientationchange", ()=> {
            crossbrowsing()
        })
    }

    _news()
    {
        let self = this

        let $section = $('.Home__news')
        let $container = $section.find('.Home__news__container')
        let $news = $container.find('.item')

        if( window.innerWidth >= 768 ){
            $section.css('height', $('.Home__products .product').first().outerHeight())
        } else{
            if( typeof $section.attr('style') != 'undefined' ){
                $section.removeAttr('style')
            }
        }

        let actionsForTruncateStrings = ( elem ) => {
            let truncatedOk = false
            let $content = elem.find('.item__content')
            let currentHeight = 0

            let controller = setInterval(function(){
                currentHeight = $content.parent().outerHeight()
                currentHeight += $content.parent().siblings('.item__social').outerHeight()

                if( currentHeight <= $content.parents('.item').outerHeight() * 0.95 ){
                    elem.addClass('-truncated')
                    
                    if( $('html').hasClass('safari7') || $('html').hasClass('safari8') || $('html').hasClass('safari9') ){
                        elem.parent().removeClass('truncated', 300, 'swing')
                    }

                    truncatedOk = true
                } else{
                    let newText = _.truncate($content.children('p').text(), {
                        'length': $content.children('p').text().length - 20,
                        'separator': '...'
                    })

                    $content.children('p').text(newText)
                }

                if( truncatedOk ){
                    clearInterval(controller)
                }
            }, 50)
        }

        let generatorSlide = ( callback ) => {
            $container.append( '<div class="swiper-wrapper"></div>' )

            $.each($container.find('.item'), function( i,val ){
                let $itemNew = $(this).clone()

                $itemNew.removeClass('col col_xs-12_sm-12').addClass('swiper-slide')

                $(this).siblings('.swiper-wrapper').append($itemNew)
                $(this).addClass('show_mobile_desktop')
            })

            self.$newsSlide = new Swiper('.Home__news__container', {
                slidesPerView: 2,
                nextButton: '.Home__news__nextButton'
            })

            callback()
        }

        generatorSlide(function(){
            $news = $container.find('.item')

            $.each($news, function( i,val ){
                self.truncateStrings.createUniqueContainer( $(this).find('.item__content') )
                
                if( window.innerWidth >= 768 ){
                    actionsForTruncateStrings( $(this) )
                }
            })
        })

        // Animation for button view more
        let $viewAll = $('.Home__news__viewall')
        $viewAll.children().hover(
            function() {
                if( !$viewAll.find('img').hasClass('hoverAnimate') ){
                    $viewAll.find('img').addClass('hoverAnimate')
                    setTimeout(function(){
                        $viewAll.find('img').removeClass('hoverAnimate')
                    }, 1500)
                }
            }, function() { }
        )

        let crossbrowsing = () => {
            $container.children().last().css({
                'height' : $container.children().first().outerHeight()
            })
        }

        if( $('html').hasClass('safari7') ){
            crossbrowsing()
        }

        $(window).resize( ()=> {
            if( window.innerWidth >= 768 ){
                $section.css('height', $('.Home__products .product').first().outerHeight())
            } else{
                if( typeof $section.attr('style') != 'undefined' ){
                    $section.removeAttr('style')
                }
            }

            if( $('html').hasClass('safari7') ){
                crossbrowsing()
            }
            
            if ( !$.isEmptyObject(self.$newsSlide) ) {
                self.$newsSlide.update()
            }
        })

        $(window).on("orientationchange", ()=> {
            if( window.innerWidth >= 768 ){
                $section.css('height', $('.Home__products .product').first().outerHeight())
            } else{
                if( typeof $section.attr('style') != 'undefined' ){
                    $section.removeAttr('style')
                }
            }

            if( $('html').hasClass('safari7') ){
                crossbrowsing()
            }

            if ( !$.isEmptyObject(self.$newsSlide) ) {
                self.$newsSlide.update()
            }
        })
    }

    _products(){
        let self = this
        let $elem = $('.Home__products')
        let $title = $elem.children('.Home__products__title')
        let $newsItems = $('.Home__news__container .item')
        let $mainContainer = $elem.children('.Home__products__container')
        let $products = $mainContainer.find('.product')
        let itemsToShow = 0
        
        let resizerLayout = () => {
            if( window.innerWidth >= 1024 ){
                // Adjust layout in desktop
                $title.css({
                    'max-width' : $newsItems.first().outerWidth()
                })
                $mainContainer.css({
                    'max-width' : $elem.outerWidth() - $newsItems.first().outerWidth()
                })
                $products.css({
                    'width' : $newsItems.first().outerWidth()
                })
            } else{
                if( typeof $title.attr('style') != 'undefined' ){
                    $title.removeAttr('style')
                }
                if( typeof $mainContainer.attr('style') != 'undefined' ){
                    $mainContainer.removeAttr('style')
                }
            }
        }

        let generatorSlide = () => {
            if (window.innerWidth >= 1024) {
                itemsToShow = 'auto'
            } else {
                if (window.innerWidth >= 900) {
                    itemsToShow = 3
                } else {
                    if( window.innerWidth >= 500 ){
                        itemsToShow = 2
                    } else{
                        itemsToShow = 1
                    }
                }
            }

            if ($products.length <= itemsToShow) {
                $mainContainer.addClass('without-slide grid-noGutter-justify-top')
                $products.addClass('col')
                return false
            }

            $products.addClass('swiper-slide')
            $mainContainer.addClass('with-slide')
            $mainContainer.append('<div class="swiper-wrapper"></div>')
            $mainContainer.append(`<a href="#" class="buttons_controls prev grid-noGutter-middle"><img src="${theme_url}/images/icons/chevron_right_white.svg" alt=""></a>`)
            $mainContainer.append(`<a href="#" class="buttons_controls next grid-noGutter-middle"><img src="${theme_url}/images/icons/chevron_right_white.svg" alt=""></a>`)
            
            let $container = $mainContainer.find('.swiper-wrapper')
            $.each($products, function (i, val) {
                $container.append($(this))
            })

            // self.$productSlide = new Swiper('.Home__products__container', {
            //     slidesPerView: itemsToShow,
            //     prevButton: '.Home__products__container .buttons_controls.prev',
            //     nextButton: '.Home__products__container .buttons_controls.next',
            //     mousewheelControl: true
            // })
        }

        resizerLayout()
        generatorSlide()

        let crossbrowsing = () => {
            $mainContainer.find('.swiper-wrapper').css({
                'height' : $mainContainer.outerHeight()
            })

            $.each($products, function( i,val ){
                let currentsrc = $(this).find('.product__info img').attr('src');

                $(this).find('.product__info img').attr('src', currentsrc + '?v=1');
            })
        }

        if( $('html').hasClass('safari7') ){
            crossbrowsing()
        } else if( $('html').hasClass('safari9') ){
            if( $('html').hasClass('ipad') ){
                crossbrowsing()
            }
        }

        $(window).resize( ()=> {
            resizerLayout()

            if ( !$.isEmptyObject(self.$productSlide) ) {
                let itemsToShow = 0

                if (window.innerWidth >= 1024) {
                    itemsToShow = 'auto'
                } else {
                    if (window.innerWidth >= 900) {
                        itemsToShow = 3
                    } else {
                        if( window.innerWidth >= 500 ){
                            itemsToShow = 2
                        } else{
                            itemsToShow = 1
                        }
                    }
                }

                if (self.$productSlide.params.slidesPerView != itemsToShow) {
                    self.$productSlide.params.slidesPerView = itemsToShow
                }

                // self.$productSlide.update()
            }

            if( $('html').hasClass('safari7') ){
                crossbrowsing()
            } else if( $('html').hasClass('safari9') ){
                if( $('html').hasClass('ipad') ){
                    crossbrowsing()
                }
            }
        })

        $(window).on("orientationchange", ()=> {
            resizerLayout()

            if ( !$.isEmptyObject(self.$productSlide) ) {
                let itemsToShow = 0

                if (window.innerWidth >= 1024) {
                    itemsToShow = 'auto'
                } else {
                    if (window.innerWidth >= 900) {
                        itemsToShow = 3
                    } else {
                        if( window.innerWidth >= 500 ){
                            itemsToShow = 2
                        } else{
                            itemsToShow = 1
                        }
                    }
                }

                if (self.$productSlide.params.slidesPerView != itemsToShow) {
                    self.$productSlide.params.slidesPerView = itemsToShow
                }

                self.$productSlide.update()
            }

            if( $('html').hasClass('safari7') ){
                crossbrowsing()
            } else if( $('html').hasClass('safari9') ){
                if( $('html').hasClass('ipad') ){
                    crossbrowsing()
                }
            }
        })
    }

    _sustainability()
    {
        let self = this
        let $elem = $('.Home__sustainability')

        $elem.mousemove(function( event ){
            let valueToMoveX = ( event.pageX * 100 ) / window.innerWidth

            valueToMoveX = Math.floor(valueToMoveX)

            $('.Home__sustainability__bg img').css({
                'transform' : 'translate3d(' + valueToMoveX + 'px, 0px, 0px)'
            })
        })

        let $container = $elem.find('.Home__sustainability__content__container')
        $.each($container.children(), function( i,val ){
            let idElem = $(this).children().attr('data-item')

            idElem = idElem.toLowerCase()

            $(this).find('svg').attr('id', idElem)

            let objAnimation = new Vivus(idElem, { duration: 150, }, function(){ })
            objAnimation.stop()
            self.svgSostenibilidad.push( objAnimation )

            if( window.scrollY + window.innerHeight >= $container.offset().top ){
                setTimeout(function(){
                    objAnimation.play()
                }, 1500)

                $(this).addClass('animation_done')
            }
        })

        $( window ).scroll( ()=> {
            if( window.scrollY + window.innerHeight >= $container.offset().top ){
                $.each(self.svgSostenibilidad, function( i,val ){
                    let $elem = $('#' + this.el.id).parent()
                    if( $elem.hasClass('animation_done') ){
                        $elem.addClass('animation_done')

                        if( typeof $(this) == 'object' ){
                            $(this)[0].play()
                        }
                        else{
                            $(this).play()
                        }
                    }
                })
            }
        })
    }
}
